module.exports = __webpack_public_path__ + "static/Logo globetrotter-368163638020e5b80ea832dbfd8980b9.jpg";